/**
 * How the SPA shows an open enum's `unknown` (D37, docs/compatibility.md §4.3):
 * a value a newer server sent that this build does not know. Neutral, with a
 * hint that a reload (or an update) will name it — never a crash.
 */
export const UNKNOWN_LABEL = 'Unknown';
export const UNKNOWN_HINT = 'A value from a newer release that this page does not know yet: reload to see it.';
